export function normalizeLocale(locale?: string): string {
	if (!locale) return 'zh-CN';
	if (locale.startsWith('es-MX')) return 'es-MX';
	if (locale.startsWith('es')) return 'es-ES';
	if (locale.startsWith('zh-TW') || locale.startsWith('zh-HK')) return 'zh-TW';
	if (locale.startsWith('en')) return 'en-US';
	if (locale.startsWith('ar')) return 'ar-SA';
	return 'zh-CN';
}

export function marketTimeZone(locale?: string): string | undefined {
	return normalizeLocale(locale) === 'es-MX' ? 'America/Mexico_City' : undefined;
}

export function marketCurrency(locale?: string): 'MXN' | 'CNY' {
	return normalizeLocale(locale) === 'es-MX' ? 'MXN' : 'CNY';
}

export function formatNumber(value: number, locale?: string): string {
	return new Intl.NumberFormat(normalizeLocale(locale)).format(value);
}

export function formatCurrency(value: number, locale?: string): string {
	return new Intl.NumberFormat(normalizeLocale(locale), {
		style: 'currency',
		currency: marketCurrency(locale),
		maximumFractionDigits: 0,
	}).format(value);
}

export function formatDate(value: Date | string, locale?: string): string {
	return new Intl.DateTimeFormat(normalizeLocale(locale), {
		year: 'numeric',
		month: 'short',
		day: '2-digit',
		timeZone: marketTimeZone(locale),
	}).format(toDate(value));
}

export function formatShortDate(value: Date | string, locale?: string): string {
	return new Intl.DateTimeFormat(normalizeLocale(locale), {
		month: 'short',
		day: '2-digit',
		timeZone: marketTimeZone(locale),
	}).format(toDate(value));
}

export function formatDateRange(start: Date | string, end: Date | string, locale?: string): string {
	return `${formatShortDate(start, locale)} - ${formatShortDate(end, locale)}`;
}

function toDate(value: Date | string): Date {
	if (value instanceof Date) return value;
	const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
	if (m) {
		const [, y, month, day] = m;
		return new Date(Date.UTC(Number(y), Number(month) - 1, Number(day), 12));
	}
	return new Date(value);
}
